export const navyBlue = "#04337A"; // ui.darkBlue.700
export const greyDarkRGB = "29, 29, 29"; // #1d1d1d ui.greyDark.700
export const navyBlueWithOpacity = "rgba(4, 51, 122, 0.18)"; // ui.darkBlue.700 with opacity
export const greyDarkWithOpacity = `rgba(${greyDarkRGB}, 0.08)`; // #1d1d1d ui.greyDark.700
export const greyDarkWithOpacityHex = "#EDEDED";
export const greyLightWithOpacity = "rgba(234, 235, 236, 0.4)"; // #eaebec ui.greyLight.50
export const greenWithOpacity = "rgba(15, 134, 112, 0.15)"; // #0f8670 ui.green.500
export const dangerRedWithOpacity = "rgba(221, 54, 54, 0.15)"; // #dd3636 ui.red.500
export const yellowDark = "#FDAD2F"; // ui.yellow.500
export const customGreen = "#D3F7EF";
